/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var G = Object.assign || function(e) {
  for (var n, t = 1, o = arguments.length; t < o; t++) {
    n = arguments[t];
    for (var a in n)
      Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
  }
  return e;
}, V = [
  ["firefox", /Firefox\/([0-9\.]+)(?:\s|$)/],
  ["opera", /Opera\/([0-9\.]+)(?:\s|$)/],
  ["opera", /OPR\/([0-9\.]+)(:?\s|$)$/],
  ["edge", /Edge\/([0-9\._]+)/],
  ["ie", /Trident\/7\.0.*rv\:([0-9\.]+)\).*Gecko$/],
  ["ie", /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/],
  ["ie", /MSIE\s(7\.0)/],
  ["safari", /Version\/([0-9\._]+).*Safari/],
  ["chrome", /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/],
  ["bb10", /BB10;\sTouch.*Version\/([0-9\.]+)/],
  ["android", /Android\s([0-9\.]+)/],
  ["ios", /Version\/([0-9\._]+).*Mobile.*Safari.*/],
  ["yandexbrowser", /YaBrowser\/([0-9\._]+)/],
  ["crios", /CriOS\/([0-9\.]+)(:?\s|$)/]
], q = [
  "Windows Phone",
  "Android",
  "CentOS",
  { name: "Chrome OS", pattern: "CrOS" },
  "Debian",
  "Fedora",
  "FreeBSD",
  "Gentoo",
  "Haiku",
  "Kubuntu",
  "Linux Mint",
  "OpenBSD",
  "Red Hat",
  "SuSE",
  "Ubuntu",
  "Xubuntu",
  "Cygwin",
  "Symbian OS",
  "hpwOS",
  "webOS ",
  "webOS",
  "Tablet OS",
  "Tizen",
  "Linux",
  "Mac OS X",
  "Macintosh",
  "Mac",
  "Windows 98;",
  "Windows "
], U = {
  "10.0": "10",
  "6.4": "10 Technical Preview",
  "6.3": "8.1",
  "6.2": "8",
  "6.1": "Server 2008 R2 / 7",
  "6.0": "Server 2008 / Vista",
  "5.2": "Server 2003 / XP 64-bit",
  "5.1": "XP",
  "5.01": "2000 SP1",
  "5.0": "2000",
  "4.0": "NT",
  "4.90": "ME"
}, H = new RegExp([
  "(android|bb\\d+|meego).+mobile|avantgo|bada\\/|blackberry|blazer|",
  "compal|elaine|fennec|hiptop|iemobile|ip(hone|od|ad)|iris|kindle|lge |maemo|",
  "midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)",
  "\\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\\.(browser|link)|vodafone|",
  "wap|windows ce|xda|xiino"
].join(""), "i"), J = new RegExp([
  "1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\\-)|",
  "ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\\-m|r |s )|",
  "avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\\-(n|u)|c55\\/|capi|ccwa|cdm\\-|",
  "cell|chtm|cldc|cmd\\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\\-s|devi|dica|dmob|do(c|p)o|",
  "ds(12|\\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\\-|_)|",
  "g1 u|g560|gene|gf\\-5|g\\-mo|go(\\.w|od)|gr(ad|un)|haie|hcit|hd\\-(m|p|t)|hei\\-|",
  "hi(pt|ta)|hp( i|ip)|hs\\-c|ht(c(\\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\\-(20|go|ma)|",
  "i230|iac( |\\-|\\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|",
  "kddi|keji|kgt( |\\/)|klon|kpt |kwc\\-|kyo(c|k)|le(no|xi)|lg( g|\\/(k|l|u)|50|54|\\-[a-w])",
  "|libw|lynx|m1\\-w|m3ga|m50\\/|ma(te|ui|xo)|mc(01|21|ca)|m\\-cr|me(rc|ri)|mi(o8|oa|ts)|",
  "mmef|mo(01|02|bi|de|do|t(\\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|",
  "n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|",
  "op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\\-2|",
  "po(ck|rt|se)|prox|psio|pt\\-g|qa\\-a|qc(07|12|21|32|60|\\-[2-7]|i\\-)|qtek|r380|r600|",
  "raks|rim9|ro(ve|zo)|s55\\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\\-|oo|p\\-)|sdk\\/|",
  "se(c(\\-|0|1)|47|mc|nd|ri)|sgh\\-|shar|sie(\\-|m)|k\\-0|sl(45|id)|sm(al|ar|b3|it|t5)|",
  "so(ft|ny)|sp(01|h\\-|v\\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\\-|tdg\\-|",
  "tel(i|m)|tim\\-|t\\-mo|to(pl|sh)|ts(70|m\\-|m3|m5)|tx\\-9|up(\\.b|g1|si)|utst|v400|v750|",
  "veri|vi(rg|te)|vk(40|5[0-3]|\\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|",
  "w3c(\\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\\-|your|zeto|zte\\-"
].join(""), "i"), Q = (
  /** @class */
  function() {
    function r(e, n, t) {
      this.navigator = n, this.process = t, this.userAgent = e || (this.navigator ? n.userAgent || n.vendor : "");
    }
    return r.prototype.detect = function() {
      if (this.process && !this.userAgent) {
        var e = this.process.version.slice(1).split(".").slice(0, 3), n = Array.prototype.slice.call(e, 1).join("") || "0";
        return {
          name: "node",
          version: e.join("."),
          versionNumber: parseFloat(e[0] + "." + n),
          mobile: !1,
          os: this.process.platform
        };
      }
      return this.userAgent || this.handleMissingError(), G({}, this.checkBrowser(), this.checkMobile(), this.checkOs());
    }, r.prototype.checkBrowser = function() {
      var e = this;
      return V.filter(function(n) {
        return n[1].test(e.userAgent);
      }).map(function(n) {
        var t = n[1].exec(e.userAgent), o = t && t[1].split(/[._]/).slice(0, 3), a = Array.prototype.slice.call(o, 1).join("") || "0";
        return o && o.length < 3 && Array.prototype.push.apply(o, o.length === 1 ? [0, 0] : [0]), {
          name: String(n[0]),
          version: o.join("."),
          versionNumber: +(o[0] + "." + a)
        };
      }).shift();
    }, r.prototype.checkMobile = function() {
      var e = this.userAgent.substr(0, 4), n = H.test(this.userAgent) || J.test(e);
      return { mobile: n };
    }, r.prototype.checkOs = function() {
      var e = this;
      return q.map(function(n) {
        var t = n.name || n, o = e.getOsPattern(n);
        return {
          name: t,
          pattern: o,
          value: RegExp("\\b" + o.replace(/([ -])(?!$)/g, "$1?") + "(?:x?[\\d._]+|[ \\w.]*)", "i").exec(e.userAgent)
        };
      }).filter(function(n) {
        return n.value;
      }).map(function(n) {
        var t = n.value[0] || "", o;
        return n.pattern && n.name && /^Win/i.test(t) && !/^Windows Phone /i.test(t) && (o = U[t.replace(/[^\d.]/g, "")]) && (t = "Windows " + o), n.pattern && n.name && (t = t.replace(RegExp(n.pattern, "i"), n.name)), t = t.replace(/ ce$/i, " CE").replace(/\bhpw/i, "web").replace(/\bMacintosh\b/, "Mac OS").replace(/_PowerPC\b/i, " OS").replace(/\b(OS X) [^ \d]+/i, "$1").replace(/\bMac (OS X)\b/, "$1").replace(/\/(\d)/, " $1").replace(/_/g, ".").replace(/(?: BePC|[ .]*fc[ \d.]+)$/i, "").replace(/\bx86\.64\b/gi, "x86_64").replace(/\b(Windows Phone) OS\b/, "$1").replace(/\b(Chrome OS \w+) [\d.]+\b/, "$1").split(" on ")[0].trim(), t = /^(?:webOS|i(?:OS|P))/.test(t) ? t : t.charAt(0).toUpperCase() + t.slice(1), { os: t };
      }).shift();
    }, r.prototype.getOsPattern = function(e) {
      var n = e;
      return (typeof e == "string" ? e : void 0) || n.pattern || n.name;
    }, r.prototype.handleMissingError = function() {
      throw new Error(`Please give user-agent.
> browser(navigator.userAgent or res.headers['user-agent']).`);
    }, r;
  }()
);
function _(r, e) {
  return e = { exports: {} }, r(e, e.exports), e.exports;
}
var p = _(function(r) {
  var e = r.exports = typeof window < "u" && window.Math == Math ? window : typeof self < "u" && self.Math == Math ? self : Function("return this")();
  typeof __g == "number" && (__g = e);
}), d = _(function(r) {
  var e = r.exports = { version: "2.5.7" };
  typeof __e == "number" && (__e = e);
});
d.version;
var h = function(r) {
  return typeof r == "object" ? r !== null : typeof r == "function";
}, $ = function(r) {
  if (!h(r))
    throw TypeError(r + " is not an object!");
  return r;
}, j = function(r) {
  try {
    return !!r();
  } catch {
    return !0;
  }
}, F = !j(function() {
  return Object.defineProperty({}, "a", { get: function() {
    return 7;
  } }).a != 7;
}), k = p.document, Z = h(k) && h(k.createElement), K = function(r) {
  return Z ? k.createElement(r) : {};
}, Y = !F && !j(function() {
  return Object.defineProperty(K("div"), "a", { get: function() {
    return 7;
  } }).a != 7;
}), rr = function(r, e) {
  if (!h(r))
    return r;
  var n, t;
  if (e && typeof (n = r.toString) == "function" && !h(t = n.call(r)) || typeof (n = r.valueOf) == "function" && !h(t = n.call(r)) || !e && typeof (n = r.toString) == "function" && !h(t = n.call(r)))
    return t;
  throw TypeError("Can't convert object to primitive value");
}, er = Object.defineProperty, nr = F ? Object.defineProperty : function(e, n, t) {
  if ($(e), n = rr(n, !0), $(t), Y)
    try {
      return er(e, n, t);
    } catch {
    }
  if ("get" in t || "set" in t)
    throw TypeError("Accessors not supported!");
  return "value" in t && (e[n] = t.value), e;
}, tr = {
  f: nr
}, or = function(r, e) {
  return {
    enumerable: !(r & 1),
    configurable: !(r & 2),
    writable: !(r & 4),
    value: e
  };
}, w = F ? function(r, e, n) {
  return tr.f(r, e, or(1, n));
} : function(r, e, n) {
  return r[e] = n, r;
}, ar = {}.hasOwnProperty, I = function(r, e) {
  return ar.call(r, e);
}, ir = 0, cr = Math.random(), B = function(r) {
  return "Symbol(".concat(r === void 0 ? "" : r, ")_", (++ir + cr).toString(36));
}, ur = _(function(r) {
  var e = B("src"), n = "toString", t = Function[n], o = ("" + t).split(n);
  d.inspectSource = function(a) {
    return t.call(a);
  }, (r.exports = function(a, i, u, l) {
    var f = typeof u == "function";
    f && (I(u, "name") || w(u, "name", i)), a[i] !== u && (f && (I(u, e) || w(u, e, a[i] ? "" + a[i] : o.join(String(i)))), a === p ? a[i] = u : l ? a[i] ? a[i] = u : w(a, i, u) : (delete a[i], w(a, i, u)));
  })(Function.prototype, n, function() {
    return typeof this == "function" && this[e] || t.call(this);
  });
}), sr = function(r) {
  if (typeof r != "function")
    throw TypeError(r + " is not a function!");
  return r;
}, A = function(r, e, n) {
  if (sr(r), e === void 0)
    return r;
  switch (n) {
    case 1:
      return function(t) {
        return r.call(e, t);
      };
    case 2:
      return function(t, o) {
        return r.call(e, t, o);
      };
    case 3:
      return function(t, o, a) {
        return r.call(e, t, o, a);
      };
  }
  return function() {
    return r.apply(e, arguments);
  };
}, M = "prototype", c = function(r, e, n) {
  var t = r & c.F, o = r & c.G, a = r & c.S, i = r & c.P, u = r & c.B, l = o ? p : a ? p[e] || (p[e] = {}) : (p[e] || {})[M], f = o ? d : d[e] || (d[e] = {}), y = f[M] || (f[M] = {}), v, b, s, S;
  o && (n = e);
  for (v in n)
    b = !t && l && l[v] !== void 0, s = (b ? l : n)[v], S = u && b ? A(s, p) : i && typeof s == "function" ? A(Function.call, s) : s, l && ur(l, v, s, r & c.U), f[v] != s && w(f, v, S), i && y[v] != s && (y[v] = s);
};
p.core = d;
c.F = 1;
c.G = 2;
c.S = 4;
c.P = 8;
c.B = 16;
c.W = 32;
c.U = 64;
c.R = 128;
var m = c, fr = {}.toString, z = function(r) {
  return fr.call(r).slice(8, -1);
}, pr = Object("z").propertyIsEnumerable(0) ? Object : function(r) {
  return z(r) == "String" ? r.split("") : Object(r);
}, N = function(r) {
  if (r == null)
    throw TypeError("Can't call method on  " + r);
  return r;
}, lr = function(r) {
  return Object(N(r));
}, vr = Math.ceil, dr = Math.floor, mr = function(r) {
  return isNaN(r = +r) ? 0 : (r > 0 ? dr : vr)(r);
}, hr = Math.min, gr = function(r) {
  return r > 0 ? hr(mr(r), 9007199254740991) : 0;
}, D = Array.isArray || function(e) {
  return z(e) == "Array";
}, br = _(function(r) {
  var e = "__core-js_shared__", n = p[e] || (p[e] = {});
  (r.exports = function(t, o) {
    return n[t] || (n[t] = o !== void 0 ? o : {});
  })("versions", []).push({
    version: d.version,
    mode: "global",
    copyright: "© 2018 Denis Pushkarev (zloirock.ru)"
  });
}), wr = _(function(r) {
  var e = br("wks"), n = p.Symbol, t = typeof n == "function", o = r.exports = function(a) {
    return e[a] || (e[a] = t && n[a] || (t ? n : B)("Symbol." + a));
  };
  o.store = e;
}), _r = wr("species"), yr = function(r) {
  var e;
  return D(r) && (e = r.constructor, typeof e == "function" && (e === Array || D(e.prototype)) && (e = void 0), h(e) && (e = e[_r], e === null && (e = void 0))), e === void 0 ? Array : e;
}, Sr = function(r, e) {
  return new (yr(r))(e);
}, W = function(r, e) {
  var n = r == 1, t = r == 2, o = r == 3, a = r == 4, i = r == 6, u = r == 5 || i, l = e || Sr;
  return function(f, y, v) {
    for (var b = lr(f), s = pr(b), S = A(y, v, 3), R = gr(s.length), g = 0, P = n ? l(f, R) : t ? l(f, 0) : void 0, x, E; R > g; g++)
      if ((u || g in s) && (x = s[g], E = S(x, g, b), r)) {
        if (n)
          P[g] = E;
        else if (E)
          switch (r) {
            case 3:
              return !0;
            case 5:
              return x;
            case 6:
              return g;
            case 2:
              P.push(x);
          }
        else if (a)
          return !1;
      }
    return i ? -1 : o || a ? a : P;
  };
}, L = function(r, e) {
  return !!r && j(function() {
    e ? r.call(null, function() {
    }, 1) : r.call(null);
  });
}, xr = W(2);
m(m.P + m.F * !L([].filter, !0), "Array", {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function(e) {
    return xr(this, e, arguments[1]);
  }
});
d.Array.filter;
var Or = W(1);
m(m.P + m.F * !L([].map, !0), "Array", {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function(e) {
    return Or(this, e, arguments[1]);
  }
});
d.Array.map;
var C = `	
\v\f\r   ᠎             　\u2028\u2029\uFEFF`, O = "[" + C + "]", T = "​", jr = RegExp("^" + O + O + "*"), Pr = RegExp(O + O + "*$"), X = function(r, e, n) {
  var t = {}, o = j(function() {
    return !!C[r]() || T[r]() != T;
  }), a = t[r] = o ? e(Er) : C[r];
  n && (t[n] = a), m(m.P + m.F * o, "String", t);
}, Er = X.trim = function(r, e) {
  return r = String(N(r)), e & 1 && (r = r.replace(jr, "")), e & 2 && (r = r.replace(Pr, "")), r;
}, Mr = X;
Mr("trim", function(r) {
  return function() {
    return r(this, 3);
  };
});
d.String.trim;
var kr = typeof window < "u" ? window.navigator : void 0, Ar = typeof process < "u" ? process : void 0;
function Cr(r) {
  var e = new Q(r, kr, Ar);
  return e.detect();
}
export {
  Cr as b
};
